import React from 'react'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import PropTypes from 'prop-types'
import i18n from 'core/common/i18n'
import Typography from 'core/components/Typography'
import { StyledDangerBox } from './style'

function MessageError({ file }) {
  let explanation = ''

  if (file.error?.details?.minimum_allowed) {
    explanation = i18n.t('product.productUpload.imageMinimiumRequirementsWith', {
      minimum_allowed_height: file.error.details.minimum_allowed.height,
      minimum_allowed_width: file.error.details.minimum_allowed.width,
      error_details_unit: file.error.details.unit,
      name: file.file.name,
    })
  } else if (file?.error?.details?.form?.url) {
    explanation = i18n.t('product.productUpload.urlInvalid')
  } else if (file?.error?.details?.allowed) {
    explanation = i18n.t('product.productUpload.fileTypeInvalid')
  } else {
    explanation = file.error?.message
  }

  return (
    <StyledDangerBox display="flex" p={2} mt={3}>
      <InfoOutlinedIcon color="error" />
      <Typography pl={1} fontSize="small" color="error">
        {explanation}
      </Typography>
    </StyledDangerBox>
  )
}

MessageError.propTypes = {
  file: PropTypes.object.isRequired,
}

export default MessageError
